import React from 'react';
import { motion } from 'framer-motion';
import { Search, FileCheck, Code, Zap, Users, BarChart3, Clock } from 'lucide-react';

const steps = [
  {
    icon: <Search className="w-6 h-6 text-orcsys-500" />,
    title: "Analyse des besoins",
    description: "Nous étudions vos processus actuels et identifions les opportunités d'automatisation les plus pertinentes.",
    duration: "1-2 semaines"
  },
  {
    icon: <FileCheck className="w-6 h-6 text-orcsys-500" />,
    title: "Plan d'action",
    description: "Nous définissons une stratégie claire avec des objectifs mesurables et un calendrier précis.",
    duration: "1 semaine"
  },
  {
    icon: <Code className="w-6 h-6 text-orcsys-500" />,
    title: "Développement",
    description: "Nos professionnels développent des solutions sur mesure en utilisant les dernières technologies d'IA.",
    duration: "4-8 semaines"
  },
  {
    icon: <Users className="w-6 h-6 text-orcsys-500" />,
    title: "Formation",
    description: "Nous formons vos équipes à l'utilisation des nouveaux outils automatisés.",
    duration: "1 semaine"
  },
  {
    icon: <Zap className="w-6 h-6 text-orcsys-500" />,
    title: "Déploiement",
    description: "Mise en production progressive pour assurer une transition en douceur.",
    duration: "1-2 semaines"
  },
  {
    icon: <BarChart3 className="w-6 h-6 text-orcsys-500" />,
    title: "Suivi & Optimisation",
    description: "Nous mesurons les résultats et optimisons continuellement les processus.",
    duration: "Continu"
  }
];

const ProcessSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-slate-50">
      <div className="container px-4 mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Notre <span className="text-orcsys-500">processus</span> d'implémentation
              </h2>
              <p className="text-lg text-slate-600 max-w-3xl mx-auto">
                Une approche structurée et éprouvée pour automatiser vos processus 
                en toute sérénité.
              </p>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="relative bg-white rounded-xl p-6 shadow-sm"
              >
                {/* Step number */}
                <div className="absolute -top-3 -left-3 w-8 h-8 rounded-full bg-orcsys-500 text-white flex items-center justify-center font-bold text-sm">
                  {index + 1}
                </div>

                <div className="mb-4 mt-2">
                  <div className="w-12 h-12 rounded-lg bg-orcsys-50 flex items-center justify-center">
                    {step.icon}
                  </div>
                </div>

                <h3 className="text-lg font-semibold text-slate-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-slate-600 text-sm mb-3">
                  {step.description}
                </p>
                <div className="flex items-center text-sm text-orcsys-500 font-medium">
                  <Clock className="w-4 h-4 mr-1" />
                  {step.duration}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection; 